// Known also as Entity Type
export enum WhatIsTable {
    TABLE = "Table",
    OBJECT = "Object",
    CONTAINER = "Container",
    COLLECTION = "Collection"
}

// Known also as Schema Type
export enum TableWrapper {
    SCHEMA = "Schema",
    OBJECT = "Object",
    TABLE = "Table",
    DATABASE = "Database",
    DATASET = "Dataset"
}
